import React from "react";
import maplocation from "assets/img/icon/maplocation.png";
import { useTranslation } from "react-i18next";
import { useLanguage } from "components/Homepage/LanguageContext";

export default function Footer() {
  // french translatin import statements
  const { t } = useTranslation();
  const { changeLanguage } = useLanguage();
  // french translatin import statements end

  const handleButtonClick = () => {
    window.location.href = "tel:+1 (438) 988-1743";
  };

  const handleButtonClickMail = () => {
    window.location.href = "mailto:info@mediterraneefood.com";
  };

  return (
    <>
      <footer className="">
        <section className="relative testimonial-area">
          <div className="container relative mx-auto overflow-hidden xl:px-12 xl:py-0 py-8 grid md:grid-cols-2 grid-cols-1 gap-4">
            <div className="xl:p-12 p-8 cursor-pointer center-items shadoww-md">
              <h1 className="text-black xl:text-2xl text-xl font-semibold banner-font">
                {t("homecontent32")}
              </h1>
              {/* <button
                onClick={handleButtonClick}
                className="text-blue-dark xl:text-2xl text-xl pt-2 font-semibold banner-font no-outline"
              >
                ☏ +1 (438) 988-1743
              </button> */}
              <button
                onClick={handleButtonClickMail}
                className="text-greyy xl:text-base1 pt-1 banner-font no-outline"
              >
                info@mediterraneefood.com
              </button>
              <p className="text-greyy xl:text-base1 pt-1 banner-font">
                {t("footercontent1")}
              </p>
            </div>
            <div className="xl:p-12 md:pt-8 md:pb-8 md:p-0 p-8 cursor-pointer center-items shadoww-md">
              <img
                src={maplocation}
                alt="Your browser does not support this image"
                className="xl:w-16 lg:w-16 md:w-12 w-12"
              />
              <h1 className="text-blue-dark xl:text-2xl text-xl pt-4 font-semibold banner-font">
                {t("footercontent2")}
              </h1>
              <p className="text-greyy xl:text-base1 pt-1 banner-font">
              {t("footercontent12")}
              </p>
              <button className="px-8 py-2 bg-dark-blue mt-4 banner-font rounded-md text-white uppercase font-semibold text-xs">
                {" "}
                {t("footercontent3")}
              </button>
            </div>
            {/* <div className="xl:p-12 p-8 cursor-pointer shadoww-md">
              <h1 className="text-blue-dark xl:text-2xl text-xl text-center font-semibold banner-font">
                {/* {t("footercontent4")} 
              </h1>
              <div className="flex pt-4 xl:mx-8 justify-between border-b pb-2">
                <p className="text-greyy xl:text-base1 banner-font">
                  {t("footercontent5")}
                </p>
                <p className="text-greyy xl:text-base1 banner-font">
                  9.00 - 21.00
                </p>
              </div>
              <div className="flex pt-4 xl:mx-8 justify-between border-b pb-2">
                <p className="text-greyy xl:text-base1 banner-font">
                  {t("footercontent6")}
                </p>
                <p className="text-greyy xl:text-base1 banner-font">
                  10.00 - 22.00
                </p>
              </div>
              <div className="flex pt-4 xl:mx-8 justify-between border-b pb-2">
                <p className="text-greyy xl:text-base1 banner-font">
                  {t("footercontent7")}
                </p>
                <p className="text-greyy xl:text-base1 banner-font">
                  9.00 - 20.00
                </p>
              </div>
              <div className="flex pt-4 xl:mx-8 justify-between border-b pb-2">
                <p className="text-greyy xl:text-base1 banner-font">
                  {t("footercontent8")}
                </p>
                <p className="text-greyy xl:text-base1 banner-font">
                  8.00 - 22.00
                </p>
              </div>
            </div> */}
          </div>
        </section>
      </footer>
    </>
  );
}
